import React from 'react';
import { CalendarIcon, MessageSquareTextIcon, LayoutIcon, MailIcon, PackageIcon, BarChartIcon } from 'lucide-react';
export function Features() {
  return <section className="py-16 border-t border-black" data-id="element-64">
      <h2 className="text-2xl md:text-3xl font-bold mb-2 text-center" data-id="element-65">
        Qué Obtendrás
      </h2>
      <p className="text-center text-orange-300 mb-12" data-id="element-66">
        Todo lo que necesitas para transformar tu negocio en 4 semanas
      </p>
      <div className="grid md:grid-cols-2 gap-8" data-id="element-67">
        <div className="bg-black/30 p-6 rounded-lg flex" data-id="element-68">
          <CalendarIcon className="h-12 w-12 text-orange-500 mr-4 flex-shrink-0" data-id="element-69" />
          <div data-id="element-70">
            <h3 className="text-xl font-bold mb-2" data-id="element-71">
              4 Semanas de Entrenamiento en Vivo
            </h3>
            <p className="text-gray-300" data-id="element-72">
              Sesiones intensivas donde aprenderás y aplicarás los frameworks
              directamente a tu negocio.
            </p>
          </div>
        </div>
        <div className="bg-black/30 p-6 rounded-lg flex" data-id="element-73">
          <MessageSquareTextIcon className="h-12 w-12 text-orange-500 mr-4 flex-shrink-0" data-id="element-74" />
          <div data-id="element-75">
            <h3 className="text-xl font-bold mb-2" data-id="element-76">
              Prompts Exactos de Grandes Marcas
            </h3>
            <p className="text-gray-300" data-id="element-77">
              Accede a los mismos prompts que usan marcas de 8 y 9 cifras para
              generar contenido persuasivo.
            </p>
          </div>
        </div>
        <div className="bg-black/30 p-6 rounded-lg flex" data-id="element-78">
          <LayoutIcon className="h-12 w-12 text-orange-500 mr-4 flex-shrink-0" data-id="element-79" />
          <div data-id="element-80">
            <h3 className="text-xl font-bold mb-2" data-id="element-81">
              Landing Pages y VSLs Listos
            </h3>
            <p className="text-gray-300" data-id="element-82">
              Templates optimizados que cargan rápido y convierten visitantes en
              clientes.
            </p>
          </div>
        </div>
        <div className="bg-black/30 p-6 rounded-lg flex" data-id="element-83">
          <MailIcon className="h-12 w-12 text-orange-500 mr-4 flex-shrink-0" data-id="element-84" />
          <div data-id="element-85">
            <h3 className="text-xl font-bold mb-2" data-id="element-86">
              Secuencias de Emails Comprobadas
            </h3>
            <p className="text-gray-300" data-id="element-87">
              Frameworks de persuasión que mantienen a tus prospectos
              comprometidos hasta la compra.
            </p>
          </div>
        </div>
        <div className="bg-black/30 p-6 rounded-lg flex" data-id="element-88">
          <PackageIcon className="h-12 w-12 text-orange-500 mr-4 flex-shrink-0" data-id="element-89" />
          <div data-id="element-90">
            <h3 className="text-xl font-bold mb-2" data-id="element-91">
              Ofertas Digitales Escalables
            </h3>
            <p className="text-gray-300" data-id="element-92">
              Aprende a construir productos digitales que escalan sin costos
              altos de operación.
            </p>
          </div>
        </div>
        <div className="bg-black/30 p-6 rounded-lg flex" data-id="element-93">
          <BarChartIcon className="h-12 w-12 text-orange-500 mr-4 flex-shrink-0" data-id="element-94" />
          <div data-id="element-95">
            <h3 className="text-xl font-bold mb-2" data-id="element-96">Tracking UTM Efectivo</h3>
            <p className="text-gray-300" data-id="element-97">
              Libérate de la dependencia del píxel con estrategias de tracking
              avanzadas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}